module.exports = __webpack_public_path__ + "static/img/little-fatty.f0d31c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/little-fatty.png
// module id = 4uIN
// module chunks = 16